import { useEffect, useState } from "react";
import { Swords } from "lucide-react";
import { api } from "../../lib/api";
import { ClanLogo } from "./ClanLogo";

const PERIOD_LABEL = { day: "Daily", week: "Weekly", month: "Monthly" };

export function ClanLeaderboard({ refreshKey }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/clans/leaderboard").then((r) => setData(r.data)).catch(() => setData({ groups: [] }));
  }, [refreshKey]);

  const groups = data?.groups || [];

  return (
    <div className="panel p-6" data-testid="clan-leaderboard">
      <div className="flex items-center gap-3 mb-4">
        <Swords className="w-5 h-5 text-phosphor" />
        <div>
          <div className="text-[10px] tracking-[0.3em] text-muted-foreground">// CLAN VS CLAN</div>
          <div className="text-xs text-muted-foreground">Clans running the same challenge compete head-to-head. Score = average of each clan's top 5.</div>
        </div>
      </div>
      {groups.length === 0 ? (
        <div className="text-sm text-muted-foreground" data-testid="leaderboard-empty">No clans have an active challenge yet.</div>
      ) : (
        <div className="space-y-5">
          {groups.map((g) => (
            <div key={g.key} data-testid={`lb-group-${g.key}`} className={g.is_mine ? "border border-phosphor/40 p-4" : "border border-border p-4"}>
              <div className="flex items-center justify-between mb-3">
                <div className="text-sm font-bold">{g.challenge.label}</div>
                <div className="text-[10px] tracking-widest text-muted-foreground">
                  {PERIOD_LABEL[g.challenge.period].toUpperCase()} · {g.challenge.mode.toUpperCase()} {g.is_mine && <span className="text-phosphor ml-2">YOUR BOARD</span>}
                </div>
              </div>
              <div className="space-y-1.5">
                {g.clans.map((c) => (
                  <div key={c.id} data-testid={`lb-clan-${c.id}`} className={`flex items-center gap-3 px-3 py-2 ${c.id === data.my_clan_id ? "bg-primary/10" : "bg-background/40"}`}>
                    <span className={`w-6 font-bold ${c.rank === 1 ? "text-amber-300" : "text-muted-foreground"}`}>{c.rank}</span>
                    <ClanLogo logo={c.logo} size={28} />
                    <div className="flex-1 min-w-0">
                      <div className="text-sm font-semibold truncate">{c.name}</div>
                      <div className="text-[10px] text-muted-foreground truncate">{c.member_count} members{c.top.length ? ` · top: ${c.top.map((t) => `${t.name} ${t.best}`).join(", ")}` : ""}</div>
                    </div>
                    <div className="text-lg font-extrabold tabular-nums text-phosphor">{c.score === null ? "—" : c.score}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
